import config from '../../../config/config'

export function handleDownloadLink() {
    window.open(config.downloadLink, '_blank')
}
